import React from "react";

/**
 * Loading spinner overlay
 *
 * @param show
 * @returns {null|*}
 * @constructor
 */
export const SpinningLoader = ({ show, isProcessing }: { show: boolean; isProcessing?: boolean }) => {
  if (!show) {
    return null;
  }

  return (
    <div id="overlay-loader">
      <div className="loader-wrapper v2">
        {isProcessing
          ? <span className="processing-loader"></span>
          : <span className="loader"></span>
        }

        {isProcessing &&
          <>
            <p className="white font-size-lg mt-8 bold">Processing.</p>
            <p className="white font-size-lg bold">It may take a moment...</p>
          </>
        }
      </div>
    </div>
  );
};

export default SpinningLoader;
